import React from 'react';

function Header() {
  const headerStyle = {
    backgroundColor: '#1a1a1a',
    padding: '1rem 2rem',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const logoStyle = {
    height: '40px',
    width: 'auto'
  };

  const navStyle = {
    display: 'flex',
    gap: '1rem'
  };
  
  // Styles for the link to make it look like a button
  const linkStyle = {
    background: 'transparent',
    color: 'white',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    padding: '0.5rem 1.5rem',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'inherit',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
  };

  return (
    <header style={headerStyle}>
      <div style={containerStyle}>
        <img
          src="/Kazam_logo.png"
          alt="Kazam Logo"
          style={logoStyle}
        />
        <nav style={navStyle}>
          {/* Only the Home link remains */}
          <a
            href="https://kazam.energy/"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#dc2626';
              e.target.style.borderColor = '#dc2626';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
            }}
          >
            होम
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;